<template>
    <div>
        <Interests title="Interests" v-bind:json="json.interests" />

        <a class="url profile cv-download" href="/CV.pdf" target="_blank">Download my CV</a>

      <Experience title="Experience" v-bind:json="json.experience" />

      <Education title="Education" v-bind:json="json.education" />

      <Qualifications title="Qualifications" v-bind:json="json.qualifications" />

      <Projects title="Projects I've done" v-bind:json="json.projects"/>

      <Footer />
    </div>
</template>

<script>
import Interests from "./Interests";
import Experience from "./Experience";
import Education from "./Education";
import Qualifications from "./Qualifications";
import Projects from "./Projects";
import Footer from "./Footer"
import Json from "../data.json";

export default {
  name: "SectionContainer",
  components: {
    Interests,
    Experience,
    Education,
    Qualifications,
    Projects,
    Footer
  },
  data: function() {
    return {
      json: Json
    };
  }
};
</script>